import { ActivityQuery } from "../lib/activityQuery"
import { useDashboardQuery } from "./useDashboardQuery"

export function useActivityQuery(...args: Parameters<typeof ActivityQuery>) {
  return useDashboardQuery(ActivityQuery(...args))
}
